<div
  class="d-flex align-items-center gap-2"
  role="button"
  [ngClass]="parentclass ? parentclass : ''"
>
  @if (userDetails?.userId) {
    <span
      class="user-avatar"
      [ngClass]="class ? class : ''"
      [ngStyle]="{
        width: customWidth ? customWidth : '32px',
        'min-width': customWidth ? customWidth : '32px',
        height: customWidth ? customWidth : '32px',
      }"
      nz-button
      nz-popover
      [nzPopoverContent]="contentTemplate"
      nzPopoverPlacement="top"
      nzPopoverOverlayClassName="avatar-info-popover"
    >
      @if (!userDetails?.profile) {
        <span>
          {{
            userDetails?.firstName
              ? userDetails?.firstName?.charAt(0).toUpperCase()
              : ""
          }}{{
            userDetails?.lastName
              ? userDetails?.lastName?.charAt(0).toUpperCase()
              : ""
          }}
        </span>
      }
      @if (userDetails?.profile) {
        <img [src]="userDetails?.profile" alt="" />
      }

      <ng-template #contentTemplate>
        <app-avatar-info-popover
          class="w-100"
          [avatarId]="userDetails?.userId"
          [projectId]="userDetails.projectId"
          [from]="from"
        ></app-avatar-info-popover>
      </ng-template>
    </span>
  } @else {
    <span
      class="user-avatar"
      [ngClass]="class ? class : ''"
      [ngStyle]="{
        width: customWidth ? customWidth : '35px',
        'min-width': customWidth ? customWidth : '35px',
        height: customWidth ? customWidth : '35px',
      }"
    >
      @if (!userDetails?.profile) {
        <span>
          {{
            userDetails?.firstName
              ? userDetails?.firstName?.charAt(0).toUpperCase()
              : ""
          }}{{
            userDetails?.lastName
              ? userDetails?.lastName?.charAt(0).toUpperCase()
              : ""
          }}
        </span>
      }
      @if (userDetails?.profile) {
        <img [src]="userDetails?.profile" alt="" />
      }
    </span>
  }

  @if (showUserName) {
    <span class="usernamepopup">
      {{ userDetails?.firstName ? userDetails?.firstName : "" }}
      {{ +userDetails?.lastName ? userDetails?.lastName : "" }}
    </span>
  }

  @if (showUserName) {
    <span class="usernamepopup">
      {{
        userDetails?.firstName + " " + userDetails?.lastName
          ? userDetails?.lastName
          : ""
      }}
    </span>
  }
</div>
